'use strict';
import React, { PureComponent } from 'react';
import InputFecha from './Common/InputFecha';
import ListaModelosSeleccionados from './Common/ListaModelosSeleccionados';


class SeccionRecontabilizacion extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            todosModelosSeleccionados,
            fechaInput,
            habilitarEjecucionReconta,
            hayProcesosEnEjecucion,
            errorValidacion,
            modelosContablesSeleccionados,
            mostrarVerMas,
            esPrimerPaso
        } = this.props;


        //ACTIONS
        const {
            guardarQuitarModeloSeleccionado,
            mostrarOcultarModalContabilizadorRecontabilizador,
            ocultarBotonVerMas,
            validarInputFecha
        } = this.props;

        return (
            <div className="ContabilizadorRecontabilizador--overflowHidden">
                <InputFecha
                    esPrimerPaso={esPrimerPaso && !hayProcesosEnEjecucion}
                    validarInputFecha={validarInputFecha}

                    classContenedor={"AsientosContables--floatLeft"}
                    fechaInput={fechaInput}
                    mensajeError={errorValidacion.inputIndicadorFecha}
                    titulo={"Fecha de contabilidad original"}
                />
              
                <div className="AsientosContables--floatLeft ContabilizadorRecontabilizador__contenedorModeloContable">
                    <div className="seccionDatosGenerales__tituloSecundario">Modelo contable</div>

                    <div className={"ContabilizadorRecontabilizador__linkSeleccionar" + ((habilitarEjecucionReconta && !hayProcesosEnEjecucion) ? "" : " linkDeshabilitado")} onClick={habilitarEjecucionReconta && !hayProcesosEnEjecucion ? () => mostrarOcultarModalContabilizadorRecontabilizador("modalSeleccionModelos", true) : null}>
                        Seleccionar...
                    </div>

                    <div className="modalLogIntentosScroll ContabilizadorRecontabilizador__scrollModelosSeleccionadosEtiquetas">      
                        <ListaModelosSeleccionados
                            guardarQuitarModeloSeleccionado={guardarQuitarModeloSeleccionado} 
                            ocultarBotonVerMas={ocultarBotonVerMas}
                            
                            claseContenedor={"ContabilizadorRecontabilizador__contenedorModelosSeleccionadosPantallaPrincipal AsientosContables__contenedorModelosSeleccionadosPantallaPrincipal"}
                            considerarVerMas={true}
                            modelosContablesSeleccionados={modelosContablesSeleccionados}
                            mostrarVerMas={mostrarVerMas}
                            todosModelosSeleccionados={todosModelosSeleccionados}
                        />       
                    </div>                    
                </div>
            </div>
        );
    }
}

export default SeccionRecontabilizacion;